import style from "css/room.module.css";
import { Button, ConfigProvider, Drawer, Image, Skeleton } from "antd";
import { CloseOutlined, EnvironmentFilled } from "@ant-design/icons";

function Detail({ isOpen, onClose, room }) {
  return (
    <Drawer
      classNames={{
        content: style.room_detail_wrap,
        body: style.room_detail_conatiner,
      }}
      open={isOpen}
      height="auto"
      closable={false}
      placement="bottom"
      maskClosable={true}
      onClose={onClose}
    >
      <section className={style.room_detail_header}>
        <p className={style.room_detail_header_title}>회의실 정보</p>

        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: "#fff",
                defaultHoverBg: "#fff",
                defaultActiveBg: "#f8f8f8",
              },
            },
          }}
        >
          <Button size={36} icon={<CloseOutlined />} onClick={onClose} />
        </ConfigProvider>
      </section>

      <section className={style.room_detail_content}>
        <section className={style.room_detail_title}>
          <p>{room.title}</p>
          {room.capacity > 0 && (
            <div className={style.room_detail_capacity}>{room.capacity}명</div>
          )}
        </section>

        {room.img === "" ? (
          <Skeleton.Image className={style.room_detail_img} />
        ) : (
          <Image className={style.room_detail_img} src={room.img} />
        )}

        <section className={style.room_detail_info}>
          <div className={style.room_detail_location}>
            <EnvironmentFilled style={{ color: "#1cb691" }} />
            {room.location !== undefined && room.location.length > 0 && (
              <p>{room.location[room.location.length - 1]}</p>
            )}
          </div>

          <article className={style.room_detail_item}>
            <div className={style.room_detail_item_header}>
              <div className={style.room_detail_item_dot} />
              <p className={style.room_detail_item_title}>개방시간</p>
            </div>

            <div className={style.room_detail_item_time}>
              {room.time === undefined ||
              room.time.open === "" ||
              room.time.close === "" ? (
                <p>상시 개방</p>
              ) : (
                <>
                  <p>{room.time.open}</p>
                  <p>~</p>
                  <p>{room.time.close}</p>
                </>
              )}
            </div>
          </article>

          <div className={style.room_detail_item_dashed} />

          <article className={style.room_detail_item}>
            <div className={style.room_detail_item_header}>
              <div className={style.room_detail_item_dot} />
              <p className={style.room_detail_item_title}>비품정보</p>
            </div>

            <section className={style.room_detail_item_fixture}>
              {room.fixture !== undefined &&
                room.fixture.length > 0 &&
                room.fixture.map((item) => (
                  <div>
                    <p className={style.room_detail_fixture_title}>
                      {item.name}
                    </p>
                    <span
                      className={style.room_detail_item_fixture_separator}
                    />
                    <p className={style.room_detail_fixture_description}>
                      {item.description}
                    </p>
                  </div>
                ))}
            </section>
          </article>

          <section className={style.room_detail_endpoint}>
            <p className={style.room_detail_endpoint_title}>화상회의 장비</p>

            <section className={style.room_detail_endpoint_content}>
              <article className={style.room_detail_endpoint_item}>
                <div className={style.room_detail_item_header}>
                  <div className={style.room_detail_item_dot} />
                  <p className={style.room_detail_item_title}>단말 명</p>
                </div>

                <div className={style.room_detail_item_time}>
                  {/* {room.endpoint.name !== undefined && room.endpoint.name} */}
                </div>
              </article>

              <div className={style.room_detail_item_dashed} />

              <article className={style.room_detail_endpoint_item}>
                <div className={style.room_detail_item_header}>
                  <div className={style.room_detail_item_dot} />
                  <p className={style.room_detail_item_title}>장비 고유값</p>
                </div>

                <div className={style.room_detail_item_time}>{room.id}</div>
              </article>
            </section>
          </section>
        </section>
      </section>
    </Drawer>
  );
}

export default Detail;
